// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"ac1432c1","182":"06b533a1","292":"48e73759","617":"6cf717d0","640":"85104383","849":"7e3a401b"}[chunkId] + ".chunk.js";
};